














/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import ErrorScreen from '@/screens/errors/error-screen.vue'
import MaintenanceScreen from '@/screens/maintenance/maintenance.vue'

/* Helpers */
import WebFont from 'webfontloader'
import { get } from 'vuex-pathify'
import LocalStore from '@/helpers/localstore'

/* Data types */

/* API */
import UserAPI from '@/api/modules/user.api'

export default Vue.extend({
  metaInfo: {
    title: 'DoneDone',
    titleTemplate: titleChunk => {
      // If undefined or blank then we don't need the hyphen
      return titleChunk ? `${titleChunk}` : 'DoneDone'
    },
  },
  components: {
    ErrorScreen,
    MaintenanceScreen,
  },
  data() {
    return {
      MAINTENANCE_MODE: false,
      oneSignalPoller: null,
      oneSignalPollMax: 10,
      oneSignalPollCount: 0,
      oneSignalPollIntervalInMS: 1000,
    }
  },
  computed: {
    isLoading: get('app/isLoading'),
    error: get('app/error'),
  },
  watch: {
    error(newVal) {
      if (newVal) {
        this.$store.set('app/isLoading', false)
      }
    },
    oneSignalPollCount: {
      handler(newValue) {
        if (newValue >= this.oneSignalPollMax) {
          this.endPollForOneSignalInfo()
        }
      },
    },
  },
  async created() {
    if (process.env.VUE_APP_MAINTENANCE_MODE === '1') {
      this.MAINTENANCE_MODE = true
    }
    WebFont.load({
      google: {
        families: ['Rubik:300,400,500,600,700', 'Caveat:400'],
      },
    })
    if (this.$screen.isGoNativeApp()) {
      this.startPollForOneSignalInfo()
    }
  },
  methods: {
    startPollForOneSignalInfo() {
      // Ensure we're clearing old polling, if necessary
      this.endPollForOneSignalInfo()
      this.oneSignalPoller = setInterval(async () => {
        this.oneSignalPollCount++
        await this.fetchAndSubmitOneSignalInfo()
      }, this.oneSignalPollIntervalInMS)
    },
    endPollForOneSignalInfo() {
      clearInterval(this.oneSignalPoller)
    },
    async fetchAndSubmitOneSignalInfo() {
      // Push onesignal user device asssocation set from index.html, if necessary...
      if (LocalStore.oneSignalUserDeviceAssociationInfo) {
        this.endPollForOneSignalInfo()
        await UserAPI.post_OneSignalUserDeviceAssociation(
          LocalStore.oneSignalUserDeviceAssociationInfo,
        )
        LocalStore.clearOneSignalUserDeviceAssociationInfo()
      }
    },
  },
})
